
import {observable, action} from 'mobx';


import axios from 'axios';

import {API_URL} from '../config'


//// bOŞTA!!

export default class User {


    @observable token = null

    //sisteme giriş
    @action async getGrCode(){
        return "151"
    }





}